import { Reveal, SectionLabel } from "@/components/site/bits";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  { q: "How long does website development take?", a: "Most premium marketing sites go live in 2–4 weeks. Complex web apps with AI features typically take 4–8 weeks depending on scope." },
  { q: "What does AI automation actually cover?", a: "We automate lead capture, follow-ups, data entry, reporting, customer support and internal operations — connecting your existing tools into intelligent workflows." },
  { q: "How do AI voice agents work?", a: "Our voice agents handle inbound and outbound calls with natural conversation, qualify leads, book appointments and hand off to humans seamlessly when needed." },
  { q: "Can you build mobile apps for both iOS and Android?", a: "Yes. We build cross-platform apps with native-grade performance, plus admin dashboards and backend infrastructure." },
  { q: "What is your pricing model?", a: "We offer fixed-scope project pricing and monthly retainers for automation & support. Book a free consultation for a tailored quote." },
  { q: "Do you provide ongoing support?", a: "Absolutely. Every engagement includes post-launch support, monitoring and optimization to keep your systems scaling." },
];

export default function FAQ() {
  return (
    <section id="faq" className="relative py-28 px-6" data-testid="faq">
      <div className="mx-auto max-w-3xl">
        <Reveal>
          <SectionLabel>FAQ</SectionLabel>
          <h2 className="font-display text-4xl md:text-5xl font-bold tracking-tight">
            Questions, <span className="text-gradient">answered</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="mt-10 space-y-3" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="rounded-2xl glass px-6 border-white/10" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="text-left font-display text-base md:text-lg hover:no-underline py-5">{f.q}</AccordionTrigger>
                <AccordionContent className="text-white/60 leading-relaxed">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
